import React from "react"

import TokkenR_logo from "./TokkenR_logo.js"


/**
 * displays TOKKENR with the right coloring + optional logo
 * @param {*} props 
 * @returns 
 * 
 * TODO extract in small_components to reuse ?
 */
export default function TokkenR_Name({
	fontSize = "38px",
	fontWeight = "bold",
	withLogo = false,
	logoWidth = null,
	style = {},
	...props
}) {
	if (!logoWidth) {
		// dynamic logo size based on text fontSize
		const numericFontSize = parseFloat(fontSize.replace("px", "")); // Remove 'px' & convert to number
		logoWidth = parseInt(numericFontSize * 2.7) + "px"
	}

	return (
		<div style={{ fontSize, fontWeight, ...style }}>
			{withLogo ?
				<TokkenR_logo logoWidth={logoWidth} />
				: null}
			Tokken<span style={{ color: "cyan" }}>R</span>
		</div>
	);
}
